/**
 * Top brand chrome bar for mobile shells.
 *
 * Sticky, navy, blur-backed, with logo + bell. Mounted at the top of mobile
 * pages via MobileShellChrome. Bell shows a "Coming soon" toast for v1.0
 * (real unread-count wiring lands in v1.1 with the dashboard redesign);
 * users tapping it previously got no feedback, which felt broken.
 */

import { Truck, Bell } from "lucide-react";
import { toast } from "sonner";

export default function MobileTopBar({ title = "Transport Anything 247" }) {
  const handleBellClick = () => {
    // v1.0 placeholder feedback — replaces the silent no-op that looked
    // like a broken button. v1.1 will open a real notifications panel.
    toast("You're all caught up", {
      description: "In-app notifications launch in the next update.",
      duration: 2200,
    });
  };
  return (
    <header className="t247-topbar" data-testid="mobile-topbar">
      <div className="t247-topbar-inner">
        <div className="t247-topbar-brand">
          <span className="t247-mark">
            <Truck size={20} strokeWidth={2.4} />
          </span>
          <span style={{ fontSize: 14, letterSpacing: "0.06em" }}>
            TRANSPORT <span style={{ color: "var(--t247-orange)" }}>247</span>
          </span>
        </div>
        <button
          type="button"
          className="t247-topbar-bell"
          aria-label="Notifications"
          data-testid="mobile-topbar-bell"
          onClick={handleBellClick}
        >
          <Bell size={18} />
        </button>
      </div>
      <span className="sr-only">{title}</span>
    </header>
  );
}
